import { Outlet } from "react-router-dom";
import { Navbar } from "@/components/ui/Navbar";
import { Footer } from "@/components/ui/Footer";

export function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-app-background text-foreground transition-colors duration-200">
      <header>
        <Navbar />
      </header>
      <main className="flex-1 pt-24 px-2">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
